import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './Navbar.css';
import { FaHome, FaClipboardList, FaUsers, FaHistory, FaRedo, FaSignOutAlt, FaLock } from 'react-icons/fa';

function Navbar() {
  const [userRole, setUserRole] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    getUserRole();
    // Set active link based on current path
    setActiveLink(window.location.pathname);
  }, []);

  const getUserRole = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data, error } = await supabase
          .from('users')
          .select('role')
          .eq('wsp_email', user.email)
          .single();

        if (error) throw error;
        setUserRole(data.role);
      }
    } catch (error) {
      console.error('Error fetching user role:', error.message);
    }
  };

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate('/'); // Redirect to login page
    } catch (error) {
      console.error('Error logging out:', error.message);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (path) => {
    setActiveLink(path);
    navigate(path);
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img
          src="/WSP_LOGO-04.png"
          alt="WSP Logo"
          className="navbar-logo"
          onClick={() => handleNavigation('/dashboard')}
        />
        <span
          className="welcome-text"
          onClick={() => handleNavigation('/cambiar-password')}
        >
          Bienvenido <strong>{userRole}</strong>
        </span>
      </div>

      <div className="menu-icon" onClick={toggleMenu}>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <div className={`navbar-right ${isMenuOpen ? 'active' : ''}`}>
        <button 
          className={`nav-button ${activeLink === '/dashboard' ? 'nav-active' : ''}`} 
          onClick={() => handleNavigation('/dashboard')}
        >
          <FaHome className="nav-icon" />
          <span>Tablero</span>
        </button>
        
        <button 
          className={`nav-button ${activeLink === '/request-viewer' ? 'nav-active' : ''}`}
          onClick={() => handleNavigation('/request-viewer')}
        >
          <FaClipboardList className="nav-icon" />
          <span>Solicitudes</span>
        </button>
        
        {/* Only show Empleados and Reactivación if userRole is set and NOT Empleado */}
        {userRole && userRole !== 'Empleado' && (
          <>
            <button 
              className={`nav-button ${activeLink === '/empleados' ? 'nav-active' : ''}`} 
              onClick={() => handleNavigation('/empleados')}
            >
              <FaUsers className="nav-icon" />
              <span>Empleados</span>
            </button>
            
            <button 
              className={`nav-button ${activeLink === '/reactivacion' ? 'nav-active' : ''}`} 
              onClick={() => handleNavigation('/reactivacion')}
            >
              <FaRedo className="nav-icon" />
              <span>Reactivación</span>
            </button>
          </>
        )}
        
        <button 
          className={`nav-button ${activeLink === '/historial' ? 'nav-active' : ''}`} 
          onClick={() => handleNavigation('/historial')}
        >
          <FaHistory className="nav-icon" />
          <span>Historial</span>
        </button>

        {/* New Contraseña button for all users */}
        <button 
          className={`nav-button ${activeLink === '/cambiar-password' ? 'nav-active' : ''}`} 
          onClick={() => handleNavigation('/cambiar-password')}
        >
          <FaLock className="nav-icon" />
          <span>Contraseña</span>
        </button>
        
        <button 
          className="nav-button logout-button" 
          onClick={handleLogout}
        >
          <FaSignOutAlt className="nav-icon" />
          <span>Cerrar Sesión</span>
        </button>
      </div>
    </nav>
  );
}
export default Navbar;